<template>
    <div v-on:scroll="handleOnScroll" id="mainContainer"  class="mainDivv">
     
        <div id="navheader" class="navheader">
            <navigation-header
                :onclickselling="scrollToSelling"
                :onclickAdvertise="scrollToAdvertisement"
                :onclickEngage="scrollToEngage"
                :onclickMarketIntelligence="scrollToMarketIntelligence"
                :onclickReachUs="scrollToReachUs"
            />
        </div>
        <div id="intro-card" class="intro-card">
            <intro-card :onclickreachus="scrollToReachUs" />
        </div>
        <!-- <hr style="opacity: 0.1" /> -->
        <div id="counterDiv" class="counterDiv">
            <farmerUser-counter />
        </div>
        <!-- <div id="about-screen" class="about-screen">
            <aboutscreen-krishify />
        </div> -->
       

        <div id="statistic-card" class="statistic-card">
            <statistic-card
                heading1="3.1 Mn+"
                heading2="140k+ "
                heading3="500k+ 
"
                subheading1="Daily Video Views+"
                subheading2="Daily Active Users"
                subheading3="Farmer to Business Daily Business Interactions"
            />
        </div>
      

        <div class="tab-detailsAdvertise" id="Advertise">
            <tab-details
                :onclickReachUs="scrollToReachUs"
                src="AdvertiseWithKrishify.png"
                srcMobile="AdvertiseWithKrishify.png"
                header="    Advertise with Krishify"
                subheader=" Know exactly what your farmers need in no time through our AI based precision targeting. 
                Filter your audience by state, crops, land size and many more. Target farmers with creative content to drive a
                uniform brand narrative and raise awareness of products. "
            />
        </div>
      

        <div id="statistic-card" class="statistic-card">
            <statistic-card
                cardNumber1="01"
                cardHeading1="Awareness and branding"
                cardSubHeading1="Target farmer community at scale driving a uniform brand narrative and awareness of your products and business"
                cardNumber2="02"
                cardHeading2="Lead generation"
                cardSubHeading2="Run lead-generation campaigns targeting specific cohorts of farmers basis geography, interests and cropping pattern"
                cardNumber3="03"
                cardHeading3="Traffic redirection"
                cardSubHeading3="Run campaigns redirecting traffic generating clicks-to-call, and website visits to capture the attention of specific farmer audiences"
            />
            <div class="image-card">
            <img height="100%" width="100%" :src="require(`@/assets/LandingPage/image.png`)" alt="" style="margin-top:2rem;margin-bottom:-6rem" />
        </div>
        </div>
      

        <!-- <div id="selling" class="tab-details">
            <tab-details
                :onclickReachUs="scrollToReachUs"
                src="StartSelling.png"
                srcMobile="StartSelling.png"
                header="Start Selling"
                subheader=" Sell your products directly to the consumers through our virtual shop. Showcase your products through reels, photos, and videos, and increase your sales. Nudge the farmers to buy from in-feed content. "
            />
        </div>
      

        <div id="Engage" class="tab-details">
            <tab-details
                :onclickReachUs="scrollToReachUs"
                src="EngageDirectly.png"
                srcMobile="EngageDirectly.png"
                header="Engage Directly"
                subheader=" Interact with your customers directly through SMS, WhatsApp, Outbound calls. Invite them to join Krishify, increase brand engagements and reach your farmers directly through in-app chat, queries and comments. "
            />
        </div> -->
      

        <!-- <section class="MarketIntelligence" id="MarketIntelligence">
            <div class="tab-details">
                <tab-details
                    :onclickReachUs="scrollToReachUs"
                    src="MarketIntelligence.png"
                    srcMobile="MarketIntelligence.png"
                    header="Market Insight"
                    subheader=" Understand the market better with data reports on consumer spending, demographics and trends. Identify new markets, understand where your products fit in. Leverage Krishify to plan your marketing cohort. "
                />
            </div>
        </section> -->
      

        <div id="trusted-companies" class="trusted-companies">
            <trusted-companies />
        </div>
 
        <div class="reach-out-to-us" id="ReachUs">
            <reach-us />
        </div>
        <div id="footer">
            <landing-pageFooter />
        </div>
  
    </div>
</template>

<script>
import navigationHeader from "./components/navigation-header.vue";
import introcard from "./components/intro-card.vue";
import farmerUserCounter from "./components/farmerUser-counter.vue";
import aboutScreenKrishify from "./components/aboutscreen-krishify.vue";
import statisticCard from "./components/statistic-card.vue";
import tabDetails from "./components/tab-details.vue";
import TrustedCompanies from "./components/trusted-companies.vue";
import ReachOutToUs from "./components/reach-us.vue";
import LandingPagefooter from "./components/footer.vue";
import MoengageEventGenerator from "../../helpers/moengageEventGenerator";
import MoengageEvents from "../../helpers/moengageEvents";
import MoengageAtrributes from "../../helpers/moengageAttributes";
export default {
    name: "landingPage",
    data() {
        return {
            srcBackground: "/FrontPage/LandingPage/headerBackground.png",
            isMobile: false,
            cardIntialTimestamp:[],
            startTime: 0,
            endTime: 0,
            timeSpent: 0,
        };
    },
    mounted(){
        this.startTime = new Date().getTime();
        // console.log("aaaaaaaaaaaa",this.startTime);
        this.checkDevices();
           for (let i = 0; i < 13; i++) {
            this.cardIntialTimestamp[i] = -1;
        }
        const moengageAttr={
                            [MoengageAtrributes.IsUserGenerated]:"FALSE",
                            [MoengageAtrributes.Origin]:"KrishifyWebPage",
                            // [MoengageAtrributes.EntitiesLoaded]:"Banner",
                            [MoengageAtrributes.Device]:!this.isMobile?"Desktop":"Mobile",
                            [MoengageAtrributes.Platform]:"Web",
                        }
                       
                        MoengageEventGenerator(MoengageEvents.LandingPageLoaded,moengageAttr);
                        this.gtagEventHandler(MoengageEvents.LandingPageLoaded,moengageAttr);
                        window.addEventListener('beforeunload', this.handleBeforeUnload);
    },
    beforeDestroy() {  
     
        this.endTime = new Date().getTime();
        this.timeSpent = this.endTime - this.startTime;
        const moengageAttrr={
                            [MoengageAtrributes.IsUserGenerated]:"TRUE",
                            [MoengageAtrributes.Source]:"BSLandingPage",
                            [MoengageAtrributes.Device]:!this.isMobile?"Desktop":"Mobile",
                            [MoengageAtrributes.Platform]:"Web",
                            [MoengageAtrributes.timeSpent]:this.timeSpent/1000,

                        }
                      
                      MoengageEventGenerator(MoengageEvents.TimeSpent,moengageAttrr);
                      this.gtagEventHandler(MoengageEvents.TimeSpent,moengageAttrr);

  },
  beforeUnmount(){
   window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
    components: {
        "navigation-header": navigationHeader,
        "intro-card": introcard,
        "farmerUser-counter": farmerUserCounter,
        "aboutscreen-krishify": aboutScreenKrishify,
        "statistic-card": statisticCard,
        "tab-details": tabDetails,
        "trusted-companies": TrustedCompanies,
        "reach-us": ReachOutToUs,
        "landing-pageFooter": LandingPagefooter,
    },
    methods: {
        gtagEventHandler(eventName, attributeValue){
            this.$gtag.event(eventName, attributeValue);
        },
        handleBeforeUnload(event) {
      // Prevent the browser from closing the tab immediately
      event.preventDefault();
      // Perform any necessary cleanup
      const moengageAttr={
                            [MoengageAtrributes.IsUserGenerated]:"TRUE",
                            [MoengageAtrributes.ButtonClicked]:"Tab Closed",
                            [MoengageAtrributes.Device]:!this.isMobile?"Desktop":"Mobile",
                            [MoengageAtrributes.Platform]:"Web",
                            [MoengageAtrributes.Source]:"BSLandingPage",
                            // [MoengageAtrributes.NextActivity]:"Reach Us Section",
                        }
                        MoengageEventGenerator(MoengageEvents.LandingPageAction,moengageAttr);
                        this.gtagEventHandler(MoengageEvents.LandingPageAction,moengageAttr);

      // Allow the tab to be closed
      event.returnValue = '';
    },
        scrollToSelling() {
            const myDiv = document.querySelector("#selling");
            myDiv?.scrollIntoView({ behavior: "smooth" });
        },
        scrollToAdvertisement() {
            const myDiv = document.querySelector("#Advertise");
            myDiv?.scrollIntoView({ behavior: "smooth" });
        },
        scrollToEngage() {
            const myDiv = document.querySelector("#Engage");
            myDiv?.scrollIntoView({ behavior: "smooth" });
        },
        scrollToMarketIntelligence() {
            const myDiv = document.querySelector("#MarketIntelligence");
            myDiv?.scrollIntoView({ behavior: "smooth" });
        },
        scrollToReachUs() {
            const myDiv = document.querySelector("#ReachUs");
            myDiv?.scrollIntoView({ behavior: "smooth" });
        },
        checkDevices() {
            let details = navigator.userAgent;
            let regexp = /android|iphone|kindle|ipad/i;
            let isMobileDevice = regexp.test(details);

            this.isMobile = isMobileDevice;
        },
         handleOnScroll  ({ target: { scrollTop, clientHeight, scrollHeight } }) {
        this.checkVisiblity();
    },
     isCardInViewport  (rect) {
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight + 250 || document.documentElement.clientHeight + 250) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    },
        checkVisiblity  () {
        const containerCard = document.getElementById("mainContainer");
        const CardList = containerCard?.children;
        // console.log(CardList, "======aaaaaa==========>");
        for (let i = 0; i < CardList.length; i++) {
            // console.log(CardList.length)
            const childCard = document.getElementById(CardList[i]?.id);
            const childRect = childCard ? childCard.getBoundingClientRect() : 0;
            const isChildVisible = this.isCardInViewport(childRect);
            // console.log(childCard.id,"======aaaaaa==========>")
            if (isChildVisible && this.cardIntialTimestamp[i] == -1 ) {
                console.log(childCard.id,"======aaaaaa==========>")
                this.cardIntialTimestamp[i] = Date.now();
            } else if (!isChildVisible  && this.cardIntialTimestamp[i] != -1) {
                const viewDuration = Math.abs(Date.now() - this.cardIntialTimestamp[i]) / 1000;
                if (viewDuration >= 3 && viewDuration < 5000) {
                    const moengageAttr={
                            [MoengageAtrributes.IsUserGenerated]:"TRUE",
                            [MoengageAtrributes.SectionsShown]:childCard.id,
                            [MoengageAtrributes.Device]:!this.isMobile?"Desktop":"Mobile",
                            [MoengageAtrributes.Platform]:"Web",
                            [MoengageAtrributes.Source]:"BSLandingPage",
                            [MoengageAtrributes.timeSpent]:viewDuration,

                            // [MoengageAtrributes.NextActivity]:"Reach Us Section",
                        }
                        MoengageEventGenerator(MoengageEvents.VerticalScroll,moengageAttr);
                        this.gtagEventHandler(MoengageEvents.VerticalScroll,moengageAttr);

                    console.log(childCard.id, i, "CALL EVENT", viewDuration);   
                }
                this.cardIntialTimestamp[i] = -1;
            }
        }
    },
    },
};
</script>

<style lang="scss" scoped>
.mainDivv {
    width: 100%;
    height: 100vh;
    overflow-y: scroll;
    position: relative;
}


.navheader {
    width: 100%;
    display: flex;
    height: 88px;
    margin: 0px auto;
    position: sticky;
    top: 0px;
    z-index: 1000;
}

.intro-card {
    width: 90%;

    margin: 0px auto;
    margin-bottom: 60px;
}

.about-screen {
    width: 80%;

    margin: 0px auto;
    margin-bottom: 60px;
}

.statistic-card {
    width: 90%;

    margin: 0px auto;
    margin-bottom: 160px;
}

.tab-details {
    width: 80%;

    margin: 0px auto;
    margin-bottom: 160px;
}
.tab-detailsAdvertise{
    width: 80%;

    margin: 0px auto;
    margin-bottom: 60px;
}

.trusted-companies {
    width: 100%;

    margin: 0px auto;
    padding-bottom:17px;
}
.image-card {
    height: 100%;
    width: 80%;
    // background: #f8f9f8;
    border-radius: 8px;
    margin: auto;
}
@media all and (max-width: 846px) {
    .trusted-companies {
        padding-bottom: 20px;
    }
}
.reach-out-to-us {
    width: 100%;
    margin: 0px auto;

    margin-bottom: 60px;
   
}

.counterDiv {
    display: flex;
    background-color: #f8f9f8;
    justify-content: center;
    max-width: 100%;
    text-align: center;
    align-items: center;
    height: 207px;
    margin-bottom: 60px;
}

@media all and (max-width: 1024px) {
    .intro-card {
        margin-bottom: 35px !important;
    }
}
@media all and (max-width: 1024px) {
    .statistic-card  {
        margin-bottom: 80px !important;
    }
}
@media all and (max-width: 1024px) {
    .tab-details {
        margin-bottom: 80px !important;
    }
}
@media all and (max-width: 1024px) {
    .tab-detailsAdvertise
 {
        margin-bottom: 28px !important;
    }
}

@media all and (max-width: 1024px) {
    .trusted-companies {
    }
}
</style>
